<template>
    <v-container>
        <v-row>
            <v-col cols="8">
                <h2 class="mt-5">Closed Positions</h2>
            </v-col>
            <v-col cols="4" class="text-right" v-if="user && user.admin">
                <v-btn color="primary" class="mt-5" @click="$refs.history.openAll()">Change Log</v-btn>
            </v-col>
            <!-- <v-col cols="4">
                <v-text-field
                    filled
                    v-model="search"
                    label="Search positions"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                ></v-text-field>
            </v-col> -->
            <!-- <v-col cols="4">
                <v-select @change="getPositions" filled label="Status" v-model="selectedStatus" :items="statusList"></v-select>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :search="search"
                    :loading="loading"
                    :headers="headers"
                    :header-props="{ sortIcon: null }"
                    :items="positions"
                    mobile-breakpoint="100"
                    class="elevation-1 datat"
                >
                    <template v-slot:[`item.current_view`]="{ item }">
                        <v-chip v-if="item.current_view == 'HOLD'" color="orange" text-color="white">{{ item.current_view }}</v-chip>
                        <v-chip v-if="item.current_view == 'CLOSE'" color="red" text-color="white">{{ item.current_view }}</v-chip>
                        <v-chip v-if="item.current_view == 'BUY'" color="green" text-color="white">{{ item.current_view }}</v-chip>
                    </template>
                    <template v-slot:[`item.entry_date`]="{ item }">
                        {{ new Date(item.entry_date).toLocaleDateString('en-IN') }}
                    </template>
                    <template v-slot:[`item.exit_date`]="{ item }">
                        <div v-if="item.exit_date">
                            {{ new Date(item.exit_date).toLocaleDateString('en-IN') }}
                        </div>
                        <div v-else>-</div>
                    </template>
                    <template v-slot:[`item.returns`]="{ item }">
                        <div v-if="item.returns <= 0" class="red--text">
                            {{ (item.returns * 100).toFixed(1) }}%
                        </div>
                        <div v-if="item.returns > 0" class="green--text">
                            {{ (item.returns * 100).toFixed(1) }}%
                        </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <div class="d-flex align-center">
                        <v-btn
                            dark
                            @click="open(item)"
                            class="ma-2"
                            color="blue"
                            rounded
                            small
                        >
                            Updates
                        </v-btn>
                        <v-btn
                            @click="openPdf(item)"
                            class="ma-2 gradient-button"
                            rounded
                            small
                        >
                            Report
                        </v-btn>
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                            v-if="user && user.admin"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteItem(item)"
                            v-if="user && user.admin"
                        >
                            mdi-delete
                        </v-icon>
                        <v-icon
                            small
                            class="ml-2"
                            @click="$refs.history.openForPosition(item)"
                            v-if="user && user.admin"
                        >
                            mdi-history
                        </v-icon>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <div>
                            <strong>Stock</strong> : It refers to NSE Symbol ||  
                            <strong>Industry</strong> : It refers to Basic Industry as defined in NSE ||  
                            <strong>Market Cap</strong> : It refers to segregation of stocks in Large, Mid and Small capitalization. ||  
                            <strong>Max Entry</strong> : It refers to Maximum Buy price Investors can pay ||  
                            <strong>Current View</strong> : It refers to view as of today ||  
                            <strong>CMP/CL</strong> : Current market price (Open positions) or Close price (Close positions) ||  
                            <strong>Return</strong> : It refers to Absolute return generated from Max Buy price to today's market price. ||  
                            <strong>Actions - Report</strong> : Research report with original recommendation details ||  
                            <strong>Actions - Updates</strong> : Latest updates based on Quarterly results or key developments
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="dialogEdit" max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.stock" label="Stock"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.company" label="Company"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.industry" label="Industry"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.mcap" label="Market Cap"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.entry_date" label="Entry Date" type="date"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.exit_date" label="Exit Date" type="date"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.max_entry" label="Max Entry" type="number"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-select v-model="editedItem.current_view" :items="['BUY', 'HOLD', 'CLOSE']" label="Current View"></v-select>
                                </v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.cmp" label="CMP" type="number"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.returns" label="Returns" type="number"></v-text-field></v-col>
                                <v-col cols="12" sm="6" md="4"><v-text-field v-model="editedItem.package" label="Package"></v-text-field></v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeEdit">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog
            v-model="loadingDialog"
            hide-overlay
            persistent
            width="300"
            >
            <v-card
                color="primary"
                dark
            >
                <v-card-text>
                Please stand by
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
                </v-card-text>
            </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog1"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">
                <v-card v-if="dialog1">
                    <v-toolbar
                    dark
                    color="primary"
                    >
                    <v-btn
                        icon
                        dark
                        @click="close"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ item.stock }} | {{ item.company }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-row>
                        <v-col cols="12">
                            <PdfViewer :pdfUrl="pdf" />
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition">
                <v-card v-if="dialog">
                    <v-toolbar
                    dark
                    color="primary"
                    >
                    <v-btn
                        icon
                        dark
                        @click="close"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ item.stock }} | {{ item.company }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-container class="no-select" @contextmenu.prevent>
                        <v-row>
                            <v-col cols="12">
                                <viewer :initialValue="research_data" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row>
        <PositionHistory ref="history" />
    </v-container>
</template>

<script>
import {supabase} from '../supabase'
import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
// import PdfViewerSmall from './PdfViewer.vue';
import PdfViewer from './PdfViewer1.vue';
import PositionHistory from './PositionHistory.vue';
export default {
    data: () => ({
        headers: [
            // { text: 'Stock', value: 'stock', sortable: false, align: 'center' },
            // { text: 'Company', value: 'company', sortable: false, align: 'center' },
            // { text: 'Industry', value: 'industry', sortable: false, align: 'center' },
            // { text: 'Market Cap', value: 'mcap', sortable: false, align: 'center' },
            // { text: 'Entry Date', value: 'entry_date', sortable: false, align: 'center' },
            // { text: 'Exit Date', value: 'exit_date', sortable: false, align: 'center' },
            // { text: 'Max Entry', value: 'max_entry', sortable: false, align: 'center' },
            // { text: 'Current View', value: 'current_view', sortable: false, align: 'center' },
            // { text: 'CMP', value: 'cmp' , sortable: false, align: 'center'},
            // { text: 'Return', value: 'return', sortable: false, align: 'center' },
        ],
        positions: [],
        loading: false,
        search: '',
        statusList: ['ALL', 'BUY', 'HOLD', 'CLOSE'],
        selectedStatus: 'ALL',
        loadingDialog: false,
        research_data: '',
        pdf: '',
        dialog: false,
        dialog1: false,
        item: null,
        dialogEdit: false,
        editedIndex: -1,
        editedItem: {
            stock: '',
            company: '',
            industry: '',
            mcap: '',
            entry_date: '',
            exit_date: '',
            max_entry: 0,
            current_view: 'CLOSE',
            cmp: 0,
            returns: 0,
            package: ''
        },
        defaultItem: {
            stock: '',
            company: '',
            industry: '',
            mcap: '',
            entry_date: '',
            exit_date: '',
            max_entry: 0,
            current_view: 'CLOSE',
            cmp: 0,
            returns: 0,
            package: ''
        },
    }),

    methods: {
        async getPositions () {
            this.loading = true;
            this.positions = []
            if(this.selectedStatus == 'ALL') {
                const { data, error } = await supabase
                    .from('positions')
                    .select('*')
                    .eq('current_view', 'CLOSE')
                    .order('entry_date', { ascending: false })
                    
                if (error) {
                    console.error('Error fetching positions:', error);
                    this.loading = false;
                } else {
                    this.positions = data;
                    this.loading = false;
                }
            } else {
                const { data, error } = await supabase
                    .from('positions')
                    .select('*')
                    .eq('current_view', this.selectedStatus)
                    .order('entry_date', { ascending: false })
                if (error) {
                    console.error('Error fetching positions:', error);
                    this.loading = false;
                } else {
                    this.positions = data;
                    this.loading = false;
                }
            }
        },

        async getColumns() {
            this.loading = true
            const { data, error } = await supabase
                .from('table_map')
                .select('*')
                .order('order', { ascending: true })
            if (error) {
                console.error('Error fetching positions:', error);
                this.loading = false;
            } else {
                for(let i in data) {
                    if(data[i].enable) {
                        this.headers.push({
                            text: data[i].label,
                            value: data[i].cno,
                            sortable: true,
                            align: 'center'
                        })
                    }
                }
                this.headers.push({
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    align: 'center'
                })

                this.loading = false;
            }
        },

        async open(item){
            this.loadingDialog = true
            const { data, error } = await supabase
                .from('researches')
                .select('research_data')
                .eq('position_id', item.id)
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                console.error('Error fetching positions:', error);
                this.loadingDialog = false
            } else {
                if(data.length > 0){
                    this.research_data = data[0].research_data
                    this.item = item
                    this.dialog = true
                    this.loadingDialog = false
                }
                else{
                    this.loadingDialog = false
                    this.$store.dispatch('createAlert',{type: 'error', message: 'No research found'})
                }
            }
        },

        async openPdf(item) {
            this.loadingDialog = true
            const { data, error } = await supabase
                .from('researches')
                .select('pdf')
                .eq('position_id', item.id)
            
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                console.error('Error fetching positions:', error);
                this.loadingDialog = false
            } else {
                if(data.length > 0){
                    this.pdf = data[0].pdf
                    this.item = item
                    this.dialog1 = true
                    this.loadingDialog = false
                }
                else{
                    this.loadingDialog = false
                    this.$store.dispatch('createAlert',{type: 'error', message: 'No research found'})
                }
            }
        },

        close() {
            this.loadingDialog = false
            this.dialog = false
            this.dialog1 = false
            this.item = null
        },

        editItem (item) {
            this.editedIndex = this.positions.indexOf(item)
            this.editedItem = Object.assign({}, item)
            if (this.editedItem.entry_date) this.editedItem.entry_date = new Date(this.editedItem.entry_date).toISOString().substr(0, 10)
            if (this.editedItem.exit_date) this.editedItem.exit_date = new Date(this.editedItem.exit_date).toISOString().substr(0, 10)
            this.dialogEdit = true
        },

        async deleteItem (item) {
            const index = this.positions.indexOf(item)
            if (confirm('Are you sure you want to delete this item?')) {
                const { error } = await supabase
                    .from('positions')
                    .delete()
                    .eq('id', item.id)
                if (error) {
                    console.error('Error deleting position:', error)
                    this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                } else {
                    this.positions.splice(index, 1)
                    this.$store.dispatch('createAlert',{type: 'success', message: 'Position deleted successfully'})
                }
            }
        },

        closeEdit () {
            this.dialogEdit = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        async save () {
            this.loadingDialog = true
            if (this.editedIndex > -1) {
                const { error } = await supabase
                    .from('positions')
                    .update(this.editedItem)
                    .eq('id', this.editedItem.id)
                
                if (error) {
                    console.error('Error updating position:', error)
                    this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                } else {
                    Object.assign(this.positions[this.editedIndex], this.editedItem)
                    this.$store.dispatch('createAlert',{type: 'success', message: 'Position updated successfully'})
                }
            }
            this.loadingDialog = false
            this.closeEdit()
        }
    },

    components: { Viewer, PdfViewer, PositionHistory, // PdfViewerSmall
    },

    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'New Position' : 'Edit Position'
        },
        user() {
            return this.$store.getters.loadedUser
        },
    },

    async mounted() {
        if(this.positions.length == 0) {
            this.getPositions()
            this.getColumns()
        }
    },
}
</script>